import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';
import { useNavbarContainerHeight } from '@garnish/navigation';

import { JoinForm } from '../../../JoinScreen/subcomponents';

// ─────────────────────────────────────────────────────────────────────────────

export const JoinOrSignInForm = (props: JoinOrSignInFormProps) => {
  const { email, isLoading, onSubmit, onSignInUsingDifferentAccount } = props;

  const { currentBreakpoint } = useResponsive();
  const { paddingBottomStyle: navbarPaddingBottomStyle } = useNavbarContainerHeight();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const formContentStyles = currentBreakpoint.isXS
    ? [styles.formContentXS, navbarPaddingBottomStyle]
    : undefined;

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.outerContainer}>
      <JoinForm
        predefinedEmail={email}
        contentStyle={formContentStyles}
        onPressJoin={onSubmit}
        onPressUseDifferentAccount={onSignInUsingDifferentAccount}
        isLoading={isLoading}
      />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
  },
  formContentXS: {
    paddingTop: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type JoinOrSignInFormProps = {
  isLoading: boolean;
  email: string | undefined;
  onSubmit: ComponentProps<typeof JoinForm>['onPressJoin'];
  onSignInUsingDifferentAccount?: () => void;
};
